/**
 * A Turnstile token is single-use SERVER-SIDE. Once the API redeems it, a retry
 * carrying the same token fails for a different reason than the first attempt
 * (timeout-or-duplicate rather than a real challenge failure), and the user sees
 * a captcha that "just keeps failing".
 *
 * So a captcha rejection is not an ordinary submit error: it has to discard the
 * spent token AND make the widget mint a new one. This helper names the one
 * response that means it, so all three landing forms agree on the definition.
 *
 * The API answers 401 { error: "captcha_failed" } from turnstileGate; every
 * other 401 on these public routes is something else and stays a generic error.
 */
export async function isCaptchaRejection(res: Response): Promise<boolean> {
  if (res.status !== 401) return false;
  const body = (await res.json().catch(() => null)) as { error?: string } | null;
  return body?.error === "captcha_failed";
}
